import { render, staticRenderFns } from "./DayShiftList.vue?vue&type=template&id=7519a8b4&scoped=true&"
import script from "./DayShiftList.vue?vue&type=script&lang=js&"
export * from "./DayShiftList.vue?vue&type=script&lang=js&"
import style0 from "./DayShiftList.vue?vue&type=style&index=0&id=7519a8b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7519a8b4",
  null
  
)

export default component.exports